var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-824.000000, -835.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Time",
    transform: "translate(824.000000, 835.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,16.96875 L11.624,16.96875 C10.084,16.96875 8.836,16 8.836,14.0625 L15,14.0625 L15,8.10565625 C15,6.61475 16,5.40575 18,5.40575 L18,16.96875 Z M16,0.5 C7.164,0.5 0,7.440125 0,16 C0,24.5608438 7.164,31.5 16,31.5 C24.837,31.5 32,24.5608438 32,16 C32,7.440125 24.837,0.5 16,0.5 L16,0.5 Z",
    id: 158
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionTime);
export default __webpack_public_path__ + "static/media/navigation-and-action-time.3bd57ff5.svg";
export { ForwardRef as ReactComponent };